module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wisave"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('el-row', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-button', {
    attrs: {
      "loading": _vm.saving,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.saving ? _vm.$t('SAVING') : _vm.$t('SAVE')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)]), _vm._v(" "), _c('el-auth-dialog', {
    attrs: {
      "visible": _vm.sessionDialog,
      "configuration": _vm.data,
      "message": "REQUIREDAUTHENTICATION"
    },
    on: {
      "authBack": _vm.success,
      "update:visible": function($event) {
        _vm.sessionDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ced60c4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Save.vue
// module id = 627
// module chunks = 1